/**
 * The coarsest MUI Rating precision that draws `value` exactly. At precision 0.1 a Rating builds ten
 * overlay items per star, fifty icons for five stars, and a page of news cards ran to a thousand of
 * them. News importance is a whole number out of 10, so its stars are whole or half: precision 1 or 0.5
 * draws the same stars from five or ten items. Any other value keeps 0.1.
 */
export const ratingPrecision = (value: number): number => (Number.isInteger(value) ? 1 : Number.isInteger(value * 2) ? 0.5 : 0.1);
